import { IBrandSummaryData } from "./IBrandSummaryData";

export interface IBrandOverviewTableRecord {
  key: string;
  brandSummary: IBrandSummaryData;
  rank: number;
  idealCustomerCount: React.ReactNode;
  idealCustomerRatio: React.ReactNode;
  idealCustomerSimilarity: React.ReactNode;
}
